import { ApiClient } from '@startuptools/common/api';
import { JwtService } from '../injectables/jwt.service';
import { host } from '../../environments/environment';

const service = new JwtService();

export const apiClient = new ApiClient({ clientApiUrl: host.clientUrl, jwt: service.jwt as string });
